export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/sales.d77f01b.svg";